/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Display_ChangeInputs */

const vi_customer_display_change = /** @type {(inputs: Customer_Display_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền thừa`)
};

/**

* @param {Customer_Display_ChangeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_display_change = /** @type {((inputs?: Customer_Display_ChangeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Display_ChangeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_display_change(inputs)
});